import { useEffect, useState } from "react";
import { useNotify, useRecordContext, useRefresh } from "react-admin";
import { Button } from "@mui/material";
import {
  completeScrapBooking,
  sendJobToCL,
} from "../../../../../Utils/RestUtils";
import { AgentAssignValidator } from "../../ViewAgentsPanel/AgentAssignValidator";
import { getAgentAssignedToLeadByOfferHistory } from "../../../../../Utils/QuoteRequestUtils";
import CancelBookingModal from "../CancelBookingModal";
import PropTypes from "prop-types";

const CompleteBookingButtonScrap = ({
  termsRead,
  termsConfirmed,
  isPriceUpdatePending,
}) => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();
  const [canCompleteBooking, setCanCompleteBooking] = useState(false);
  const [assignedAgent, setAssignedAgent] = useState(false);
  const [completeBookingQueued, setCompleteBookingQueued] = useState(false);
  const [resendToCLQueued, setResendToCLQueued] = useState(false);
  const isBookingCompleted = record.bookingCompleted;
  const roles = localStorage.getItem("permissions").split(",");

  useEffect(() => {
    setCanCompleteBooking(termsConfirmed === true);

    const offer = getAgentAssignedToLeadByOfferHistory(record.offerHistory);
    if (offer !== undefined) {
      setAssignedAgent(offer.collector);
    }
  }, [termsRead, termsConfirmed, refresh]);

  useEffect(() => {
    if (!isPriceUpdatePending && completeBookingQueued) {
      setCompleteBookingQueued(false);
      handleCompleteBooking();
    }
  }, [isPriceUpdatePending, completeBookingQueued]);

  useEffect(() => {
    if (!isPriceUpdatePending && resendToCLQueued) {
      setResendToCLQueued(false);
      handleResendToCL();
    }
  }, [isPriceUpdatePending, resendToCLQueued]);

  const handleResendToCL = async () => {
    if (isPriceUpdatePending) {
      setResendToCLQueued(true);

      return;
    }

    const response = await sendJobToCL(record.originId);

    if (response.status !== 200) {
      notify(response.data.errors, { type: "error" });
    } else {
      notify("Successfully sent job to Collector Logic", { type: "success" });
    }
  };

  const handleCompleteBooking = async () => {
    if (isPriceUpdatePending) {
      setCompleteBookingQueued(true);

      return;
    }

    const errors = await AgentAssignValidator(record, assignedAgent.id);
    if (errors === false) {
      //Means that it is under outstanding finance and agent didn't want to proceed
      return;
    }

    if (errors.length > 0) {
      notify(
        "Please fix below issues in order to assign an agent: \n\n" +
          errors.join(";\n"),
        { type: "error", multiLine: true }
      );
      return;
    }

    const bookingResponse = await completeScrapBooking({
      quoteRequestId: record["@id"],
    });

    if (bookingResponse.result === "success") {
      refresh();
      notify("Booking successfully assigned", { type: "success" });
    } else {
      notify(bookingResponse.error_msg, { type: "error" });
    }
  };

  return !isBookingCompleted ? (
    <Button
      variant="contained"
      disabled={
        (isPriceUpdatePending && completeBookingQueued) ||
        (!canCompleteBooking && !isBookingCompleted)
      }
      fullWidth
      onClick={handleCompleteBooking}
    >
      Assign & Complete Booking
    </Button>
  ) : (
    <>
      {record.status === "Collected" &&
        (roles.includes("ROLE_ADMIN") || roles.includes("ROLE_MANAGER")) && (
          <Button
            variant="contained"
            fullWidth
            disabled={isPriceUpdatePending && resendToCLQueued}
            onClick={handleResendToCL}
          >
            Resend to collector logic
          </Button>
        )}
      <CancelBookingModal />
    </>
  );
};

export default CompleteBookingButtonScrap;

CompleteBookingButtonScrap.propTypes = {
  termsRead: PropTypes.bool,
  termsConfirmed: PropTypes.bool,
  isPriceUpdatePending: PropTypes.bool,
};
